<template>
  <div class="toolsHead">
    <div class="left">
      <img
        src="@/assets/images/logo.png"
        class="left-logo"
        alt
        @click="backToHome()"
      />
    </div>

    <div class="right">
      <!-- <div class="language">
        <img src="@/assets/images/language.png" class="language-img" alt />
      </div> -->

      <el-select
        v-model="chainId"
        placeholder=""
        class="coin"
        :popper-append-to-body="false"
        :no-data-text="'暂无数据'"
        :no-match-text="'Unknow'"
        @change="selectNetworkFunction"
      >
        <el-option
          v-for="item in chainOptions"
          :key="item.value"
          :label="item.name"
          :value="item.chainId"
        >
        </el-option>
      </el-select>

      <!-- <div class="wallet flex-row" >
          <img src="@/assets/images/wallet.png" class="wallet-img" alt />
           <div>连接钱包</div>
        </div> -->
      <!-- <div class="coin" v-if="account.length > 0">
        {{ getCurrentChainName() }}
      </div> -->

      <div
        class="wallet flex-row"
        @click="connectWallet"
        v-if="account.length == 0"
      >
        <img src="@/assets/images/wallet.png" class="wallet-img" alt />
        <div>连接钱包</div>
      </div>
      <div v-else>
        <el-dropdown trigger="click" @command="handleCommand">
          <div class="wallet flex-row">
            <img src="@/assets/images/wallet.png" class="wallet-img" alt />
            <div>{{ account | addressEll }}</div>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              command="1"
              class="copyAddress"
              @click.native="copyText($event, account)"
              >复制地址</el-dropdown-item
            >
            <el-dropdown-item command="2" divided>断开连接</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>
<script>
import { requestContractGas } from "@/config/api.js";
import { nodeConfigs } from "@/config/config.js";
import Clipboard from "clipboard";
export default {
  data() {
    return {
      chainOptions: nodeConfigs,
      walletValue: "",
      account: "",
      chainId: null,
    };
  },
  mounted() {
    //刷新最新合约发布手续费
    this.refreshGas();
    if (localStorage.getItem("TokenBox-account")) {
      //更新本地存储的account 与 chainId
      this.account = localStorage.getItem("TokenBox-account");
      this.getChainID();
    } else if (localStorage.getItem("TokenBox-chainID")) {
      this.chainId = parseInt(localStorage.getItem("TokenBox-chainID")) 
    } else {
      this.chainId = 56;
      localStorage.setItem("TokenBox-chainID", 56);
    }
    // this.getChainID();
    var that = this;
    //监听钱包账户变化
    if (!window.ethereum) {
      //this.$showErrorMessage("当前环境未安装钱包");
      return;
    }
    try {
      window.ethereum.on("accountsChanged", function (accounts) {
        if (accounts.length === 0) {
          console.log("Please connect to MetaMask.");
          that.account = "";
          localStorage.setItem("TokenBox-account", that.account);
        } else if (accounts[0] !== localStorage.getItem("TokenBox-account")) {
          console.log("accountsChanged");
          that.account = accounts[0];
          localStorage.setItem("TokenBox-account", that.account);
          window.location.reload();
        }
      });
      //监听钱包主链变化
      window.ethereum.on("chainChanged", function (chainId) {
        console.log("chainChanged", parseInt(chainId));
        // that.chainId = chainId;
        localStorage.setItem("TokenBox-chainID", parseInt(chainId));
        if (that.account.length == 0) that.connectWallet();
        window.location.reload();
      });
    } catch (error) {
      this.$showErrorMessage(error);
    }
  },
  methods: {
    backToHome() {
      this.$router.push("/");
    },
    async connectWallet() {
      if (window.ethereum && window.ethereum.isMetaMask == true) {
        console.log("MetaMask is installed!");
        window.ethereum
          .request({ method: "eth_requestAccounts" })
          .then((res) => {
            if (res) {
              console.log("connectWallet");
              this.account = res[0];
              localStorage.setItem("TokenBox-account", this.account);
              window.location.reload();
            }
            console.log(res);
          })
          .catch((err) => {
            if (err.code === 4001) {
              console.log("Please connect to MetaMask.");
            } else {
              console.error(err);
            }
          });
      } else {
        this.$showErrorMessage("请先安装钱包");
      }
    },
    getChainID() {
      try {
        window.ethereum
          .request({ method: "eth_chainId" })
          .then((res) => {
            this.chainId = parseInt(res);
            console.log("head-chainId=", res);
            localStorage.setItem("TokenBox-chainID", this.chainId);
          })
          .catch((err) => {
            console.error(err);
          });
      } catch (error) {}
    },
    async selectNetworkFunction(chainId) {
      var data = this.chainOptions.filter((item) => item.chainId == chainId);
      console.log("selectNetwork=", data);
      if (!data || data.length == 0) {
        return;
      }
      console.log("switchEthereumChain=", chainId);
      try {
        await window.ethereum.request({
          method: "wallet_switchEthereumChain",
          params: [{ chainId: "0x" + chainId.toString(16) }],
        });
        console.log("wallet_switchEthereumChain");
      } catch (switchError) {
        console.log("switchError=", switchError);
        // This error code indicates that the chain has not been added to MetaMask.
        if (switchError.code === 4902) {
          try {
            await window.ethereum.request({
              method: "wallet_addEthereumChain",
              params: [
                {
                  chainId: "0x" + chainId.toString(16),
                  chainName: data[0].name,
                  rpcUrls: [data[0].rpc],

                  nativeCurrency: {
                    name: data[0].symbol,
                    symbol: data[0].symbol,
                    decimals: 18,
                  },
                },
              ],
            });
          } catch (addError) {
            // Handle "add" error.
            console.log("addError=", addError);
            window.location.reload();
          }
        }
        if (switchError.code === 4001) {
          //User rejected the request.
          window.location.reload();
        }
        // Handle other "switch" errors.
      }
    },
    async refreshGas() {
      var res = await requestContractGas();
      var that = this;
      if (res && res.data) {
        localStorage.setItem("TokenBox-gas", JSON.stringify(res.data));
      }
    },
    handleCommand(command) {
      if (command == 2) {
        this.account = "";
        localStorage.setItem("TokenBox-account", this.account);
        window.ethereum.request({
          method: "wallet_revokePermissions",
          params: [
            {
              eth_accounts: {},
            },
          ],
        });
      }
    },
    copyText(e, text) {
      const clipboard = new Clipboard(e.target, {
        text() {
          return text;
        },
      });

      clipboard.on("success", () => {
        this.$message.success("复制成功！");
        clipboard.destroy();
      });

      clipboard.on("error", (e) => {
        console.log("该浏览器不支持自动复制!", "warning", e);
        clipboard.destroy();
      });

      clipboard.onClick(e);
    },
    getCurrentChainName() {
      if (this.chainId <= 0) {
        return;
      }
      var res = getChainConfig();
      if (res) {
        console.log("getCurrentChainName", res.name);
        return res.name;
      }
      return "Other Mainnet";
    },
  },
};
</script>

<style lang="scss" scoped>
.toolsHead {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  height: 40px;
  width: 100%;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(25px);

  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 10px 2%;
  color: white;

  .left {
    width: 144px;
    height: 40px;
    .left-logo {
      width: 144px;
      height: 40px;
      object-fit: contain;
      cursor: pointer;
    }
  }

  .right {
    display: flex;
    justify-content: center;
    align-items: center;

    .language {
      width: 25px;
      height: 25px;
      margin: 0 60px 0 0;
      .language-img {
        width: 100%;
        height: 100%;
        cursor: pointer;
      }
    }

    .coin {
      margin: 0 20px 0 0;

      /deep/.el-input__inner {
        width: 150px;
        height: 36px;
        border-radius: 30px 30px 30px 30px;
        border: 1px solid #ffffff;
        background: transparent;

        font-weight: 400;
        font-size: 14px;
        color: #ffffff;
        line-height: 16px;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }

      /deep/.el-select-dropdown {
        width: 130px;
        // background: #d9d9d9;
        border-radius: 8px 8px 8px 8px;
        font-weight: 400;
        font-size: 14px;
        color: #8f8f8f;
        line-height: 16px;
        text-align: center;
        font-style: normal;
        text-transform: none;

        top: 65px !important;
      }

      /deep/.el-select-dropdown__item:hover {
        background: rgba(77, 77, 77, 0.5);
        color: #d8d8d8;
      }

      /deep/.el-select-dropdown__item.selected {
        color: #675aff;
      }

      /deep/.popper__arrow {
        left: 93px !important;
      }
    }

    .wallet {
      margin: 0 60px 0 0;
      border-radius: 30px 30px 30px 30px;
      padding: 0px 15px;
      height: 36px;
      min-width: 90px;
      line-height: 36px;
      border: 1px solid #ffffff;
      color: white;

      cursor: pointer;
      .wallet-img {
        width: 26px;
        height: 26px;
        margin: 4px 5px 5px 0;
        object-fit: contain;
      }
    }
  }
}
</style>